import { createApp } from "vue";
import api from "./api";
import LazyLoadDirective from "./directives/LazyLoadDirective";
import { UtilitiesHelpers } from "./utils/Utilities";
import OrelyLatestPosts from "./vueresources/OrelyLatestPosts";
let vLatestArticle = document.getElementById('v-latest-posts');
vLatestArticle = createApp({
    beforeCreate() {
        UtilitiesHelpers.vueFixWpPlugins(document.querySelector('#v-latest-posts'));
        UtilitiesHelpers.forceExternalLinks();
    },
}).directive("lazyload", LazyLoadDirective);
vLatestArticle.config.globalProperties.$settings = settings;
vLatestArticle.config.globalProperties.$api = api;
vLatestArticle.component("orely-latest-posts", OrelyLatestPosts);
vLatestArticle.mount('#v-latest-posts');